import type { LucideIcon } from 'lucide-react';
import * as React from 'react';
import { cn } from '@/lib/utils';

type EmptyStateProps = {
  icon: LucideIcon;
  title: string;
  description: string;
  action?: React.ReactNode;
  className?: string;
};

export const EmptyState = ({
  icon: Icon,
  title,
  description,
  action,
  className,
}: EmptyStateProps) => (
  <div
    className={cn(
      'flex flex-col items-center justify-center px-6 py-14 text-center',
      className,
    )}
  >
    <div className="mb-4 flex size-11 items-center justify-center rounded-full bg-surface-muted">
      <Icon className="size-5 text-ink-subtle" aria-hidden />
    </div>
    <p className="text-sm font-medium text-ink">{title}</p>
    <p className="mt-1 max-w-sm text-sm text-ink-muted">{description}</p>
    {action ? <div className="mt-5">{action}</div> : null}
  </div>
);
